<template>
    <section class="contact mt-8 pt-6">
        <div class="flex items-center mb-[1.2142857rem]">
            <Icon :icon="icon" class="mr-[0.714rem] text-gray-900 text-[1.286rem]" />
            <Heading :level="4" color="text-ash-200">
                {{ heading }}
            </Heading>
        </div>
        <div class="text-[1rem] pt-[1.2142857rem] leading-[1.71428571rem] text-ash-100 border-t border-gray-300">
            <p>
                {{ description }}
                <NuxtLink :to="`mailto:${email}`" id="media-mail" :aria-label="email" :title="`Send a mail to ${email}`" class="text-black underline hover:text-gold-100 transition-colors" external>
                    {{ email }}
                </NuxtLink>
            </p>
        </div>
    </section>
</template>

<script setup lang="ts">
import Heading from '../../atom/heading.vue'
import Icon from '../../atom/icon.vue'
import type { ContactProps } from '~~/shared/types/common'

withDefaults(defineProps<ContactProps>(), {
    icon: 'microphone',
    heading: 'Press Contact',
    description: 'For press inquiries, please email us at ',
    email: 'media@thorne.com'
})
</script>
